import React, { useState } from 'react';
import * as Styles from './styles';

const helpFaqQuestions = [
    {
        question: 'What is ACKO Drive Service Centre?',
        answer: 'ACKO Drive Service Centre is a network of multi-brand service centres providing best-in-class car servicing & repairs at affordable prices. We offer high quality services through our certified & trained professionals, top quality equipment and using original parts.',
    },
    {
        question: 'Why should I choose ACKO Drive Service Centre?',
        answer: 'ACKO Drive Service Centre offers a hassle-free car service/repair experience with our Pickup & Drop facility and real-time updates on the ACKO app. We take pride in having a pool of certified & trained professionals, best-in-class equipment and usage of original parts. We also offer same-day car delivery for periodic service ensuring your car is back on road at the earliest.',
    },
    {
        question: 'How are you able to offer low prices?',
        answer: 'We charge a lesser premium on labor compared to OEM service centres. We are able to reduce operational costs through quick turnaround times, lean operations, and bulk procurement of parts. All these benefits are passed to our customers in the form of lower prices.',
    },
    {
        question: 'How do I make a booking?',
        answer: 'You can book your appointment on the ACKO App. To book your appointment, go to ACKO App home page -> Click on “Book A Car Service” -> Select the service you are looking for -> Fill in your car details -> Enter your address for car pickup -> Pay the booking fee (which will be adjusted in your final bill) -> Choose your preferred slot and your booking will be confirmed. Our Field executive will come to your location to pickup your car at your preferred time slot.',
    },
    {
        question: 'How do I reschedule/cancel my booking?',
        answer: 'You can reschedule/cancel your booking up to 12 hrs before the pickup time slot. Any payments made will be refunded within 3 working days. To reschedule/cancel your booking go to: ACKO App -> Book A Car Service -> Visit My Bookings -> Click on Modify Bookings -> Cancel or Reschedule the booking as per your requirement.',
    },
    {
        question: 'Is there a Booking Fee?',
        answer: 'We charge a booking fee of ₹100. This amount is adjusted in your final bill.',
    },
    {
        question: 'Do I need to pay before the service?',
        answer: 'No, you don’t have to make any payment before availing our services. We will charge a booking fee of ₹100 in case you choose our Pickup service. This fee will be adjusted in your final bill.',
    },
    {
        question: 'Will I get a cost estimate before authorizing the repairs?',
        answer: 'Once your car is in our service centre, a Service Advisor will be assigned to you. The Advisor will inspect your vehicle and share the estimate with you on the ACKO app. We will begin the repairs/services on your car only once you approve the estimate on the ACKO app, ensuring full transparency.',
    },
    {
        question: 'Do you use original parts?',
        answer: 'We use only original parts for all servicing/repairs.',
    },
    {
        question: 'How to find the nearest center?',
        answer: 'Visit the ACKO App, scroll down to Book a Car Service. We will automatically map you to the nearest centre based on your pincode.',
    },
    {
        question: 'Which car brands do you service?',
        answer: 'We service all cars of the following brands: Maruti Suzuki, Hyundai, Tata, Mahindra, Toyota, Volkswagen, Skoda, Renault, Nissan, Ford, Kia, Chevrolet.',
    },
    {
        question: 'Is this only for ACKO General Insurance customers?',
        answer: 'No, our services are not limited to customers of ACKO General Insurance. Any car owner can get their car serviced/repaired at our Service Centres.',
    },
    {
        question: 'What kind of services do you offer?',
        answer: 'We are fully equipped to provide all types of car services/repairs including denting & painting work, periodic maintenance, general repairs, Value Added Services, etc.',
    },
    {
        question: 'Which Engine Oil do you use?',
        answer: 'We source our engine oil from Exxon Mobil, one of the world’s largest manufacturers of lubricants/engine oil.',
    },
    {
        question: 'How do I contact you?',
        answer: 'You can contact us by dialing our toll-free number 1800-266-9293. You can find this number on the Google Maps listing of your nearest service centre. You can also contact us through the “Help” section of the booking flow.',
    },
    {
        question: 'Do you have a cashless tie-up with my insurance company?',
        answer: 'We provide repair services for claims made under all insurance companies. However, at present, we do not have a cashless tie-up with any insurance company except ACKO General Insurance. You will have to contact your insurer to get the claim amount reimbursement.',
    },
    {
        question: 'Where can I know the status of my car?',
        answer: 'Once you book an appointment at ACKO Drive Service centre, you can track the status of your car repair on the ACKO app by opening the “car service” section or click on the tracking link shared by you over WhatsApp.',
    },
    {
        question: 'Do you offer towing services?',
        answer: 'At present, we do not offer towing services. However, we are working to enable this for our customers soon.',
    },
    {
        question: 'Which payment methods do you accept?',
        answer: 'We accept payments from all major channels like Credit Cards, Debit Cards, UPI, Wallets, Net Banking etc.',
    },
    {
        question: 'How long does it take to complete a service or repair?',
        answer: 'For periodic maintenance, we offer same-day delivery if the car arrives at the workshop before 1 pm. For cars received post 1 pm, we offer next day delivery. For other repairs, the delivery time depends on the exact nature of repairs, part availability, etc.',
    },
];

export default function HelpFAQ() {
    const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

    const handleToggle = (index: number) => {
        setExpandedIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    return (
        <Styles.Container>
            <Styles.Heading>Check if the FAQs have your answer</Styles.Heading>

            <Styles.ListItems>
                {helpFaqQuestions.map((item, index) => (
                    <Styles.ListComponent
                        key={index}
                        onClick={() => handleToggle(index)}
                    >
                        <Styles.ListItem>
                            {item.question}
                            <Styles.ChevronDown
                                className={
                                    expandedIndex === index ? 'rotated' : ''
                                }
                            />
                        </Styles.ListItem>
                        {expandedIndex === index && (
                            <Styles.DropdownContent>
                                {item.answer}
                            </Styles.DropdownContent>
                        )}
                    </Styles.ListComponent>
                ))}
            </Styles.ListItems>
        </Styles.Container>
    );
}
